/* Compact bundle labels reuse the merchant's existing Variation Display names.
   Only tray labels change; the Kaching picker, product data and selling plans
   stay native. Unknown products retain their original descriptive names. */
(() => {
  'use strict';
  if (window.__c2o3KachingUiLoaded) return;
  window.__c2o3KachingUiLoaded = true;

  function productHandle(href) {
    try {
      return new URL(href, location.href).pathname.match(/\/products\/([^/]+)/)?.[1];
    } catch {
      return null;
    }
  }

  function syncLabels() {
    document.querySelectorAll('product-info').forEach((info) => {
      const names = new Map();
      try {
        const flavors = JSON.parse(info.querySelector('[data-c2o3-kaching-flavors]')?.textContent || '[]');
        flavors.forEach(({ handle, name }) => {
          if (handle && typeof name === 'string' && name.trim()) names.set(handle, name.trim());
        });
      } catch {
        // An older/custom section can still supply names through its swatches.
      }
      info.querySelectorAll('.c2o3-variation__item[href]').forEach((swatch) => {
        const name = swatch.querySelector('.c2o3-variation__name')?.textContent.trim();
        const handle = productHandle(swatch.getAttribute('href'));
        if (name && handle) names.set(handle, name);
      });
      if (!names.size) return;

      info.querySelectorAll('kaching-bundles-block').forEach((widget) => {
        let product;
        try {
          product = JSON.parse(widget.getAttribute('product') || '{}');
        } catch {
          return;
        }
        widget.querySelectorAll('.kaching-bundles__bar-collection-products .kaching-bundles__collection-product__title').forEach((title) => {
          const item = title.closest('.kaching-bundles__collection-product');
          const link = item.querySelector('a[href]');
          const text = title.textContent.trim();
          // The base product has no link. Match its full or previously shortened
          // title so a different unlinked item can never inherit its flavor.
          const currentName = names.get(product.handle);
          const name = link ? names.get(productHandle(link.getAttribute('href')))
            : (text === product.title || text === currentName ? currentName : null);
          // Keep the text node itself: the app retains its reference for updates.
          const textNode = [...title.childNodes].find((node) => node.nodeType === Node.TEXT_NODE);
          if (name && text !== name && textNode) textNode.nodeValue = name;
        });
      });
    });
  }

  function init() {
    let frame = 0;
    const observer = new MutationObserver((records) => {
      if (frame) return;
      const relevant = records.some((record) => {
        const target = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
        return target?.closest('product-info') || [...record.addedNodes].some((node) =>
          node.nodeType === Node.ELEMENT_NODE && (node.matches('product-info') || node.querySelector('product-info'))
        );
      });
      if (relevant) frame = requestAnimationFrame(() => { frame = 0; syncLabels(); });
    });
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
    syncLabels();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
